import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a18ef962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cell-box xag-container" }
const _hoisted_2 = { class: "cell auto-height" }
const _hoisted_3 = { class: "xag-flex-lr describe-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "购买时间说明", -1))
const _hoisted_5 = { class: "cell auto-height" }
const _hoisted_6 = {
  class: "xag-flex-lr describe-header",
  style: {"margin-bottom":"13px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title xag-flex" }, [
  /*#__PURE__*/_createElementVNode("div", null, "凭证附图（发票/收据)")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_device_footer = _resolveComponent("device-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "购买凭证" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "content no-val xag-flex",
            style: _normalizeStyle({ color: _ctx.describeLen > 200 ? 'red' : '' })
          }, _toDisplayString(_ctx.describeLen) + "/200 ", 5)
        ]),
        _createVNode(_component_van_field, {
          style: {"font-size":"16px","line-height":"24px"},
          modelValue: _ctx.describe,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.describe) = $event)),
          rows: "3",
          autosize: "",
          maxlength: "200",
          type: "textarea",
          placeholder: "请输入寄修各产品的购买日期并提供凭证，以便核实保修状态。"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: "content no-val xag-flex",
            style: _normalizeStyle({ color: _ctx.fLen > 3 ? 'red' : '' })
          }, _toDisplayString(_ctx.fLen) + "/3 ", 5)
        ]),
        _createVNode(_component_van_uploader, {
          modelValue: _ctx.fileList,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
          multiple: "",
          "max-count": 3,
          "before-delete": _ctx.beforeDelete,
          "after-read": _ctx.afterRead
        }, null, 8, ["modelValue", "before-delete", "after-read"])
      ])
    ]),
    _createVNode(_component_device_footer, {
      title: "提交",
      isCanClick: _ctx.isCanClick,
      onFooterSubmit: _ctx.onSubmitForm
    }, null, 8, ["isCanClick", "onFooterSubmit"])
  ], 64))
}